/**
 * React Query hook for fetching available configuration versions for a project.
 * Returns the list of version strings (excluding "current", which is prepended by the frontend).
 */

import { useQuery } from '@tanstack/react-query';

import { listConfigVersions } from '@/api/configuration';
import { queryKeys } from '@/modules/query/query-keys';

/**
 * Fetches the list of config versions available for a project.
 * Enabled only when projectKey is truthy.
 */
export function useConfigVersions(projectKey: string) {
  return useQuery<string[]>({
    queryKey: queryKeys.configuration.configVersions(projectKey),
    queryFn: () => listConfigVersions(projectKey),
    enabled: !!projectKey,
    retry: 1,
  });
}
